import { render, staticRenderFns } from "./RichTextWidgetPanel.vue?vue&type=template&id=7f4181b4&scoped=true"
import script from "./RichTextWidgetPanel.vue?vue&type=script&lang=js"
export * from "./RichTextWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./RichTextWidgetPanel.vue?vue&type=style&index=0&id=7f4181b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4181b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f4181b4')) {
      api.createRecord('7f4181b4', component.options)
    } else {
      api.reload('7f4181b4', component.options)
    }
    module.hot.accept("./RichTextWidgetPanel.vue?vue&type=template&id=7f4181b4&scoped=true", function () {
      api.rerender('7f4181b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/settingPanel/RichTextWidgetPanel.vue"
export default component.exports